import React, { useEffect, useState } from "react";
import { Tooltip, OverlayTrigger, Card } from 'react-bootstrap';
import Modal from 'react-bootstrap/Modal';
import { default as Select, components }  from "react-select";
import $ from "jquery";
import * as ReactDOM from 'react-dom';
import "datatables.net";
import {getFilenameFromURL,getUsername,formatDate} from "../../utils/common_functions"
import {API_SUCCESS_RESPONSE_CODE,API_SUCCESS_RESPONSE_CREATED_CODE} from "../../utils/config_mapping"
import CommonIcon from '../common/customicon';
import PageLoader from '../common/pageloader';
import ProcessLoader from '../common/processloader';
import "../../../node_modules/datatables.net-dt/css/dataTables.dataTables.css";
import {getAllTaxonomy,createTaxonomy,deleteTaxonomy,updateTaxonomy, getAllClauses} from "../../services/admin"
import Message from "../common/message";
import { JsonView, allExpanded, darkStyles, defaultStyles } from 'react-json-view-lite';
import 'react-json-view-lite/dist/index.css';
import Error from "../common/error";


const taxonomies_options = [
  { value: 'finance', label: 'Finance' },
  { value: 'legal', label: 'Legal' },
  { value: 'mergers', label: 'Mergers & Acquisitions' },
  { value: 'procurement', label: 'Procurement' },
  { value: 'real_estate', label: 'Real Estate' },
];

export const Taxonomies = () => {
  const Option = (props) => {
    return (
      <div>
        <components.Option {...props}>
          <input
            type="checkbox"
            checked={props.isSelected}
            onChange={() => null}
          />{" "}
          <label>{props.label}</label>
        </components.Option>
      </div>
    );
  };

  const [addclausemodal, setAddClausesModal] = useState(false);
  const [clausesData, setClausesData] = useState([]); // Clause options
  const handleClose = () => setAddClausesModal(false);
  const handleShow = () => setAddClausesModal(true);

  const [promptmodal, setAddPromptModal] = useState(false);
  const handlePromptClose = () => setAddPromptModal(false);
  const handlePromptShow = () => setAddPromptModal(true);

  const [deletedocumentmodal, setDeleteClausesModal] = useState(false);
  const handleDeleteClose = () => setDeleteClausesModal(false);
  const handleDeleteShow = () => setDeleteClausesModal(true);
  const [loading, setLoading] = useState(true); // State to track loading
  const [data, setData] = useState([]); // State to hold API data

  const [prompt_data
    , setPromptData] = useState([]); // State to hold API data


  const [filteredData, setFilteredData] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [filterTextClauses, setFilterTextClauses] = useState(""); // For clause filtering
  const [selectedClauses, setSelectedClauses] = useState([]); // Selected clauses
  const [filters, setFilters] = useState({
  filterstatus: null,
  filterTextSearch: ""
});
const [saveLoader,setSaveLoader] = useState("");

const initialState = {
    taxonomyName:"",
    taxonomyId:""
}

  const [formData, setFormData] = useState(initialState);
  const [errors, setErrors] = useState({});

   const handleDelete = async (event) => {
      const dataId = event.target.getAttribute('data-id');
      const targetElement = document.getElementById("app_err");
      if(dataId){
        try {
            const result = await deleteTaxonomy(dataId);
            if(result!==undefined){
              if (result.code === API_SUCCESS_RESPONSE_CODE) {
                handleDeleteClose()
                fetchData();
                if (targetElement) {
                  ReactDOM.unmountComponentAtNode(targetElement);
                }
                ReactDOM.render(<Message type='success' message={result.data.message} />, targetElement);
                
              }
            }
        } catch (error) {
          console.error("Error refreshing token:", error);
        }
      }
    };


  // Filter clauses based on the search text
  const filteredClauses = clausesData.filter((clause) =>
    clause.clauseName.toLowerCase().includes(filterTextClauses.toLowerCase())
  );

 // Handle individual clause selection (used for clicking on checkboxes manually)
const handleClauseSelection = (clause) => {
  setSelectedClauses(prevSelected => 
    prevSelected.includes(clause)
      ? prevSelected.filter(c => c !== clause) // Remove if already selected
      : [...prevSelected, clause] // Add to selected if not already there
  );
};


    const handleSaveTaxonomy = async (pmData) => {
        const targetElement = document.getElementById("app_err");
        setSaveLoader(true)
        if(pmData.taxonomyId===""){
          let tempTaxonomyType = pmData.taxonomyType
          pmData.taxonomyType = pmData.taxonomyType.value
          const result = await createTaxonomy(pmData);
          if (result.code === API_SUCCESS_RESPONSE_CREATED_CODE) {
            fetchData();
            handleClose()
            if (targetElement) {
              ReactDOM.unmountComponentAtNode(targetElement);
            }
            ReactDOM.render(<Message type='success' message={result.data.message} />, targetElement);
            setSaveLoader(false)
          } else {
            const targetElementerror = document.getElementById("uploaderror");
            if (targetElementerror) {
              ReactDOM.unmountComponentAtNode(targetElementerror);
            }
            ReactDOM.render(<Error message={result.error.message} />,targetElementerror)
            setSaveLoader(false)
            pmData.taxonomyType = tempTaxonomyType
            console.warn("Unexpected response status:", result.status);
          }
        }else{
          let tempTaxonomyType = pmData.taxonomyType
          pmData.taxonomyType = pmData.taxonomyType.value
          const result = await updateTaxonomy(pmData.taxonomyId,pmData);
          if (result.code === API_SUCCESS_RESPONSE_CODE) {
            fetchData();
            handleClose()
            if (targetElement) {
              ReactDOM.unmountComponentAtNode(targetElement);
            }
            ReactDOM.render(<Message type='success' message={result.data.message} />, targetElement);
            setSaveLoader(false)
          } else {
            const targetElementerror = document.getElementById("uploaderror");
            if (targetElementerror) {
              ReactDOM.unmountComponentAtNode(targetElementerror);
            }
            ReactDOM.render(<Error message={result.error.message} />,targetElementerror)
            console.warn("Unexpected response status:", result.status);
            setSaveLoader(false)
            pmData.taxonomyType = tempTaxonomyType
          }
        }
    };

    const fetchData = async () => {
      $(".page_pro_load").hide();
      setLoading(true); // Stop loading spinner
      try {
        const result = await getAllTaxonomy();
        if (result.code === API_SUCCESS_RESPONSE_CODE) {
          setData(result.data);
          setFilteredData(result.data); // Set initial data for filtering
        } else {
          console.warn("Unexpected response status:", result.status);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
      finally {
         setLoading(false); // Stop loading spinner
     }
    };
 useEffect(() => {
      fetchData();
 }, []); // Empty dependency array ensures this runs only once

const [selectAll, setSelectAll] = useState(false);

// Handle Select All functionality
const handleSelectAll = () => {
  if (selectAll) {
    // If "Select All" is already checked, unselect all clauses
    setSelectedClauses([]);
    setSelectAll(false);
  } else {
    // Select all currently filtered clauses
    const allFilteredClauses = filteredClauses.map(clause => clause.clauseName);
    setSelectedClauses(allFilteredClauses);
    setSelectAll(true);
  }
};


  // Handle individual clause selection (optional if needed)
  const handleClauseClick = (clause) => {
    setSelectedClauses(prevSelected =>
      prevSelected.includes(clause)
        ? prevSelected.filter(c => c !== clause)
        : [...prevSelected, clause]
    );
  };


 const fetchClauseData = async () => {
  try {
    const result = await getAllClauses();
    if (result.code === API_SUCCESS_RESPONSE_CODE && Array.isArray(result.data)) {
      // Sort the taxonomy list if it's not empty
      const sortedClausesData = [...result.data].sort((a, b) =>
                a.clauseName.localeCompare(b.clauseName)
              );
      setClausesData(sortedClausesData);
    } else {
      console.warn("Unexpected response status:", result.status);
    }
  } catch (error) {
    console.error("Error fetching data:", error);
  }
 }

 useEffect(() => {
  fetchClauseData();
}, []); // Empty dependency array ensures this runs only once

  useEffect(() => {
    if (filteredData.length > -1) {
      const table = $("#contract_grid").DataTable({
        createdRow: function(row, data, dataIndex) {
          if (data.length === 1) {
              $(row).addClass('empty-row');
          }
          },
        scrollCollapse: true,
        scrollX: true,
        pageLength: 25, // Set default number of records per page
       // scrollY:$(window).height()-($("#table_height").height()+180),
        data: filteredData,
        destroy: true, // Ensure the previous table is destroyed
        order: [],  // This disables default sorting on any column
        columnDefs: [
          { 
            targets: [4], // Center-align "Created By" column
            className: 'text-center' // Bootstrap's text-center class
          },
         
          { 
            targets: '_all', // Left-align all other columns
            className: 'text-left' // Bootstrap's text-left class
          }
        ],
        columns: [
          { data: "taxonomyName", title: "Taxonomy Name",width: "200px", },
          { data: "taxonomyType", title: "Type",width: "100px", },
          
          { data: "createdBy", title: "Created By",width: "150px", },
          { data: "createdAt", title: "Created Date&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;", width: "150px",className: "text-left", // Add this to left-align the date column
          },
            { data: "clauses", title: "Clauses",width: "100px", 
            render: function (data, type, row) { 
            if(data){
              let clause_len = data.length;
              return '<div>'+clause_len+'</div>'
              }else{ return '<div>0</div>'} } 
          },
          {
            title: "Actions",
            orderable: false, // Disable sorting for this column
            data: null,
            width: "60px", 
            createdCell: function (td, cellData, rowData, row, col) {
              // Clear the default HTML and replace it with React-rendered content
              ReactDOM.render(
                <>

<OverlayTrigger
                    placement="top"
                    trigger={['hover', 'click']} // Add 'click' to ensure it closes on click
                    overlay={<Tooltip id="view-top">Prompt</Tooltip>}
                  >
                    <a href="javascript:void(0);" className="showprompt-btn" data-rowdata={JSON.stringify(rowData)}>
                      <i className="datatable-edit-icon"></i>
                    </a>
                  </OverlayTrigger>
                  &nbsp;
                  <OverlayTrigger
                    placement="top"
                    trigger={['hover', 'click']} // Add 'click' to ensure it closes on click
                    overlay={<Tooltip id="view-top">Edit</Tooltip>}
                  >
                    <a href="javascript:void(0);" className="view-btn" data-rowdata={JSON.stringify(rowData)}>
                      <i className="datatable-pencil-icon"></i>
                    </a>
                  </OverlayTrigger>
                  &nbsp;
                  <OverlayTrigger
                    trigger={['hover', 'click']} // Add 'click' to ensure it closes on click
                    placement="top"
                    overlay={<Tooltip id="delte-top">Delete</Tooltip>}
                  >
                  <a href="javascript:void(0);" className="delete-btn" data-bs-toggle="modal"
                     data-bs-target="#confirmationModal" data-id={rowData._id} data-name={rowData.taxonomyName}>
                    <i className="datatable-delete-icon"></i>
                  </a></OverlayTrigger>
                  &nbsp;
                </>,
                td // Render the content directly into the table cell
              );
            }
          }
                 ],
        fixedColumns: {
          start: 1,
          end: 1
      },
        paging: true,
        searching: false,
        ordering: true,
        responsive: true,
        fixedHeader: true,
        language: {
          emptyTable: "No data found matching the filters",  // Custom message for no data
        },
      });


      $('.menu-icon').on('click', function() {
        // Adjust DataTable columns and redraw when the sidebar menu is toggled
        setTimeout(function() {
          table.columns.adjust().draw();
        }, 100); // Adjust the delay time based on your sidebar transition duration
      });


      $("#contract_grid").on("click", ".showprompt-btn", function () {
        const rowData = $(this).data("rowdata");
        setAddPromptModal(true); // Open the modal
        console.log(rowData.prompt)
        setPromptData(rowData.prompt)
      });


      $("#contract_grid").on("click", ".view-btn", function () {
        const rowData = $(this).data("rowdata");

        setFormData({
          taxonomyName: rowData.taxonomyName,
          taxonomyType: taxonomies_options.find(option => option.value === rowData.taxonomyType),
         // taxonomyType: taxonomies_options.find(option => option.value === rowData.taxonomyType),
          taxonomyId: rowData._id,
          clauses: rowData.clauses || [], // If clauses exist
        });

        if(rowData.clauses.length===filteredClauses.length){
          setSelectAll(true);
        }
        else {
          setSelectAll(false);
        }
        setSelectedClauses(rowData.clauses.map(clause => clause.clauseName)); // Prefill the selected clauses
        handleShow(); // Open the modal
      
      });

      $("#contract_grid").on("click", ".delete-btn", function () {
        handleDeleteShow()
        const id = $(this).data("id");
        const name = getFilenameFromURL($(this).data("name"));
        setTimeout(function() {
          $("#btn_delete").attr("data-id", id);
          $("#document_name").html(name);
        }, 200);
       });

      return () => {
        table.destroy(); // Clean up DataTable instance
      };
    }
  }, [filteredData]);

    // Search handler
    const handleSearch = (e) => {
      setSearchQuery(e.target.value);
      applyFilters(e.target.value, filters);
    };

  const validateForm = () => {
    const newErrors = {};
    if (!formData.taxonomyName) newErrors.taxonomyName = "Taxonomy name  is required.";
    if (!formData.taxonomyType) newErrors.taxonomyType = "Taxonomy type  is required.";
    if (selectedClauses.length === 0) newErrors.Associatedclauses = "Associated clauses  is required.";
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };
  
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
    setErrors((prevErrors) => ({ ...prevErrors, [name]: "" }));
  };

  const handleSelectChange = (selectedOption) => {
    setFormData((prev) => ({
      ...prev,
      taxonomyType: selectedOption  // Store the entire selected options array for multi-select
    }));
    setErrors((prevErrors) => ({ ...prevErrors, taxonomyType: "" })); // Clear error if any
  };
  

  const resetForm = (e) => {
    handleShow()
    setFormData(initialState); // Reset form fields to initial state
    setSelectedClauses([]); // Clear selected clauses
  }

  const handleSubmit = (e) => {
    const logged_user_name = getUsername();
    e.preventDefault();
    if (!validateForm()) return;
    $(".page_pro_load").show();
    if(selectedClauses.length > 0){
      formData.clauses = selectedClauses.map(item => ({ clauseName: item }));
      formData.taxonomyType = {label:formData.taxonomyType.label,value:formData.taxonomyType.value}
      if(saveLoader!==true){
          handleSaveTaxonomy(formData)
      }
    }
  };

  const handleFilterChange = (filterName, value) => {
    setFilters((prevState) => {
      const newFilters = { ...prevState, [filterName]: value };
      applyFilters(newFilters);
      return newFilters;
    });
  };

  const applyFilters = (newFilters) => {
    let filteredDataTemp = data;
    if (newFilters.filterTextSearch) { // New filter for text search
      filteredDataTemp = filteredDataTemp.filter((doc) => 
        doc.taxonomyName.toLowerCase().includes(newFilters.filterTextSearch.toLowerCase()) ||
        doc.taxonomyType.toLowerCase().includes(newFilters.filterTextSearch.toLowerCase()) ||
        doc.createdBy.toLowerCase().includes(newFilters.filterTextSearch.toLowerCase()) ||
        doc.createdAt.toLowerCase().includes(newFilters.filterTextSearch.toLowerCase())  ||
        doc._id.toLowerCase().includes(newFilters.filterTextSearch.toLowerCase())
      );
    }
    setFilteredData(filteredDataTemp);
  };

  const resetFilters = () => {
    setSearchQuery('');
    setFilters({
      filterdocumentType: null,
      filterlicensor: null,
      filterexpiryDate: '',
      filterstatus: null
    });
    setFilteredData(data); // Reset to full data
  };


  return (
    <div className="main-content">
      <div className="page-content">
        <div className="container-fluid">
          <div id="table_height">
          <div className="flex-grow-1" id="row_heading">
            <div className="page-title">Taxonomies</div>
            <p className="text-muted my-2 ff-secondary">
            Manage and organize standard contract clauses with taxonomies
            </p>
            <div id="app_err"></div>
          </div>
          { data.length > 0 ? 
          <div className="row g-2 mb-4 mt-4" id="row_search">
            <div className="col-sm-9">
              <div className="search-box">
                <input
                  type="text"
                  className="form-control"
                  id="searchClausess"
                  placeholder="Search Taxonomies..."  // This should work as expected
                  onChange={(e) => handleFilterChange('filterTextSearch', e.target.value)}
                />
                <i className="grid-search">
                <CommonIcon iconName="Search" size={"14px"}  />
                </i>
              </div>
            </div>
            <div className="col-sm-auto ms-auto">
              <div className="list-grid-nav hstack gap-1">
                <button className="btn btn-light" onClick={fetchData}>
                <CommonIcon iconName="RefreshCw" size={"14px"} color={"#000"} />
                </button>
                <button onClick={resetForm}
                  className="btn btn-primary uploadcontract-modal"
                  data-bs-toggle="modal"
                  data-bs-target="#addmemberModal"
                >
                  <CommonIcon iconName="Plus" size={"14px"} color="#fff" /> Add Taxonomy
                </button>
              </div>
            </div>
          </div> :"" }

      <div className="row d-none" id="row_filter" >
      <div className="col-lg-1 mt-2">
      <CommonIcon iconName="Filter" size={"14px"}  /> Filters:
      </div>
      <div className="col-lg-3">
      {/* <Select
            isMulti
            closeMenuOnSelect={false}
            hideSelectedOptions={false}
            components={{
              Option
            }}
            value={filters.filterdocumentType}
            onChange={(selectedOption) => handleFilterChange('filterdocumentType', selectedOption)}
            options={documentTypeOptions}
            placeholder="Clauses Type"
          /> */}
      </div>

      <div className="col-lg-3">
      {/* <Select
            isMulti
            closeMenuOnSelect={false}
            hideSelectedOptions={false}
            components={{
              Option
            }}
            value={filters.filterlicensor}
            onChange={(selectedOption) => handleFilterChange('filterlicensor', selectedOption)}
            options={licensorOptions}
            placeholder="Licensor"
          /> */}
      </div>
      <div className="col-lg-3 mb-2">
      {/* <Select
            isMulti
            closeMenuOnSelect={false}
            hideSelectedOptions={false}
            components={{
              Option
            }}
            value={filters.filterstatus}
            onChange={(selectedOption) => handleFilterChange('filterstatus', selectedOption)}
            options={statusoptions}
            placeholder="Status"
          /> */}
          </div>
      </div>
      </div>
          <div className="row">
            <div className="col-lg-12">
                  <div>
                    {/* DataTable */}
                    {loading ? (
                 <PageLoader />
            ) :  data.length > 0 ?
                (
                <div className="row  mt-4">
                  <div className="col-lg-12">
                    <table
                      id="contract_grid"
                      className="display"
                      style={{ width: "100%" }}
                    >
                      <thead>
                      </thead>
                    </table>
                  </div>
                </div>) :     <div className="mt-5 card"><div className="text-center">
      <div className="no-doc-container my-4">
        {/* Bootstrap file-earmark icon with a warning sign */}
        <CommonIcon iconName="Database" width="50" height="50" />
        <div className="mt-3">
          <i className="bi bi-exclamation-circle-fill text-danger"></i>
        </div>
      </div>
      <h4 className="text-muted mb-4">No Taxonomy Found</h4>

      <button onClick={resetForm}
                  className="btn btn-primary uploadcontract-modal mb-4"
                  data-bs-toggle="modal"
                  data-bs-target="#addmemberModal"
                >
                  <CommonIcon iconName="Plus" size={"14px"} color="#fff" /> Add Taxonomy
                </button>
                <br/>
                <br/>
    </div>
    </div>
 }
                  </div>
                </div>
              </div>
        </div>
      </div>

      <Modal show={deletedocumentmodal} onHide={handleDeleteClose}>
        <Modal.Header closeButton>
          <Modal.Title><div className="page-title" id="confirmationModalLabel">
                Delete
              </div></Modal.Title>
        </Modal.Header>
        <Modal.Body>
        <label class="form-label">Are you sure want to delete <span id="document_name"></span> taxonomy?</label>
        </Modal.Body>
        <Modal.Footer>
        <button type="button" onClick={handleDeleteClose} className="btn btn-light" data-bs-dismiss="modal"><CommonIcon iconName="X" size={"14px"} /> Close</button>
                  <button onClick={handleDelete} id="btn_delete" data-id="1111" type="submit" className="btn btn-primary">
                    <CommonIcon iconName="Trash" size={"14px"} color="#fff" /> Delete
                  </button>
        </Modal.Footer>
      </Modal>



      <Modal show={promptmodal} onHide={handlePromptClose}>
        <Modal.Header closeButton>
          <Modal.Title><div className="page-title" >
                Prompt
              </div></Modal.Title>
              <p className="modal-desc">
                      View system prompt and user prompt
            </p>

        </Modal.Header>
        <Modal.Body>
          <br/>
        <pre className="rounded" style={{height:"400px"}}>
          <JsonView data={prompt_data} shouldExpandNode={allExpanded} style={defaultStyles} />
         </pre>
        </Modal.Body>
        <Modal.Footer>
        </Modal.Footer>
      </Modal>

      


      <Modal show={addclausemodal} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title> 
                  {formData.taxonomyId==="" ? "Create New Taxonomy" : "Edit Taxonomy"}
           </Modal.Title>
           <p className="modal-desc">
           {formData.taxonomyId==="" ? "Add a new taxonomy to organize and classify contract clauses " : "Edit taxonomy to organize and classify contract clauses "}
            </p>
        </Modal.Header>
        <Modal.Body>
        <div className="modal-body">
              <form onSubmit={handleSubmit}>
                <div className="row g-3">
                  <div className="col-lg-12">
                    <label className="form-label">Taxonomy Name</label>
                    <input type="hidden" name="taxonomyId" value={formData.taxonomyId} />
                    <input
                      type="text"
                      name="taxonomyName"
                      className="form-control"
                      value={formData.taxonomyName}
                      onChange={handleInputChange}
                      placeholder="Enter clause name"
                    />
                    {errors.taxonomyName && <div className="text-danger">{errors.taxonomyName}</div>}
                  </div>

                  <div className="col-lg-12">
                    <label className="form-label">Taxonomy Type</label>
                    {console.log(formData)}
                    <Select
                        name="taxonomyType"
                        options={taxonomies_options}
                        value={formData.taxonomyType}
                        onChange={handleSelectChange}
                        placeholder="Select a Taxonomy Type"
                      />
                    {errors.taxonomyType && <div className="text-danger">{errors.taxonomyType}</div>}
                  </div>

                  <div className="row g-2 mb-1 mt-1">
                           

                            <div className="col-sm-6">
                              <label>Associated Clauses</label>
                              </div>
                              <div className="col-sm-6">
                              <label className='highlight-clause float-end'>
                                {
                                selectedClauses.length > 0 ? selectedClauses.length > 1 ? selectedClauses.length+" clauses selected": selectedClauses.length+" clause selected" : "" }
                                </label>
                              </div>

                              <div className="col-sm-12">
                             
                              <div className="search-box">
                                <input
                                  type="text"
                                  className="form-control"
                                  id="searchClauses"
                                  placeholder="Search clauses..."
                                  value={filterTextClauses}
                                  onChange={(e) => setFilterTextClauses(e.target.value)}
                                />
                                <i className="grid-search">
                                  <CommonIcon iconName="Search" size={"14px"} />
                                </i>
                              </div>
                            </div>
                  </div>

                   {/* Clauses List */}
                   <div className="card no-padding" style={{marginBottom:"0px;"}}>
                            <div className="card-heading">
                              {/* Select All checkbox */}
                              <div className="mt-2">
                                <input
                                  type="checkbox"
                                  id="selectAllClauses"
                                  checked={selectAll}
                                  onChange={handleSelectAll}
                                />&nbsp;
                                <label htmlFor="selectAllClauses" className="ml-2">
                                  Select All
                                </label>
                              </div></div>
                              <div className='card-body no-padding'>
                              <div style={{ height: "200px", overflow: "auto" }}>
                                {filteredClauses.map((clause, index) => (
                                  <div  key={index}
                                  style={{
                                    border: selectedClauses.includes(clause.clauseName) ? '0px solid #007bff' : '0px solid #ccc',
                                    borderRadius:"10px",
                                    padding: '5px 5px 5px 15px',
                                    marginBottom: '5px',
                                    cursor: 'pointer',
                                    backgroundColor: selectedClauses.includes(clause.clauseName) ? '#f3f4f5' : '#fff',
                                  }}
                                  >
                                    <div className="form-check">
                                      <input
                                        className="form-check-input"
                                        type="checkbox"
                                        id={`flexCheckDefault_${index}`}
                                        onChange={() => handleClauseSelection(clause.clauseName)}
                                        checked={selectedClauses.includes(clause.clauseName)}
                                     />
                                      <label className="form-check-label" htmlFor={`flexCheckDefault_${index}`}>
                                        {clause.clauseName}
                                      </label>
                                    </div>
                                  </div>
                                ))}
                                {filteredClauses.length===0 ? <span className='p-3'>No Clauses Found</span> : ""}
                              </div>
                            </div>
                   </div>
                   {errors.Associatedclauses && <div className="text-danger" style={{marginTop:"-15px"}}>{errors.Associatedclauses}</div>}

                <div className="page_pro_load">{
                <ProcessLoader pmMessage={"PDF upload in progress, please wait..."}  />
                }</div>
                <div id="uploaderror"></div>
                </div>
              </form>
            </div>
        </Modal.Body>
        <Modal.Footer>
        
        {console.log(formData.taxonomyName!=="" && errors.taxonomyName!==undefined &&  errors.taxonomyName===""
                && formData.taxonomyType !== undefined && formData.taxonomyType.value !==  "" 
                && selectedClauses.length > 0)}

                {console.log("----------------")}
        <button type="button" onClick={handleClose} className="btn btn-light" data-bs-dismiss="modal">
          <i className="ri-close-line align-bottom me-1"></i> Close</button>
              <button 
              disabled={(
                formData.taxonomyName!=="" && errors.taxonomyName!==undefined &&  errors.taxonomyName===""
                && formData.taxonomyType !== undefined && formData.taxonomyType.value !==  "" 
                && selectedClauses.length > 0 || formData.taxonomyId!=""
              ) ? "" : "true"} 
              onClick={handleSubmit} type="submit" className="btn btn-primary">
                {saveLoader === true ? <span className="submit-loader"></span> : ""}
                    {formData.taxonomyId===""  ? "Create Taxonomy" : "Update Taxonomy"}
               </button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};